var scope_0 = require('/home/travis/build/morewings/react-calendar-toolkit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1a71da78551e9d79c92589574dca759c.js').default;

var scope_1 = require('/home/travis/build/morewings/react-calendar-toolkit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3227ee942fd3e358d68e78a12dca8c97.js').default;

var scope_2 = require('/home/travis/build/morewings/react-calendar-toolkit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3fb88752e29c76af187b8949a8aa65b0.js').default;

var scope_3 = require('/home/travis/build/morewings/react-calendar-toolkit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/776b6a9e38e7c6b6d28018f193b7151f.js').default;

var scope_4 = require('/home/travis/build/morewings/react-calendar-toolkit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9aa8e6ab677823b441ef8461806f4821.js').default;

var scope_5 = require('/home/travis/build/morewings/react-calendar-toolkit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a00d0a3b8377180432fd1d89da9ff493.js').default;

var scope_6 = require('/home/travis/build/morewings/react-calendar-toolkit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a90c155fd0db27b4cca7bcbb531c7431.js').default;

var scope_7 = require('/home/travis/build/morewings/react-calendar-toolkit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bc59ed89e7fb271049449f794ca44b6e.js').default;

var scope_8 = require('/home/travis/build/morewings/react-calendar-toolkit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c3e0f41e57cacb80594bb3bd8ba0f956.js').default;

var scope_9 = require('/home/travis/build/morewings/react-calendar-toolkit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c590ed03be9fd8ad37d47bf7fee22f4d.js').default;

var scope_10 = require('/home/travis/build/morewings/react-calendar-toolkit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e66a953618f720d599ac6d4f7df60dfc.js').default;

var scope_11 = require('/home/travis/build/morewings/react-calendar-toolkit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

var scope_12 = require('/home/travis/build/morewings/react-calendar-toolkit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/eefa8da35ef9a2ecdf175244dce31faf.js').default;

var scope_13 = require('/home/travis/build/morewings/react-calendar-toolkit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f0ec59de47c6b0b3f8032c8f8966bd38.js').default;

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11, scope_12, scope_13);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}